import { gql } from 'apollo-angular';

export default gql`
  query GetScanById($id: ID!) {
    getScanById(id: $id) {
      id
      tenant_ref
      patient_id
      date
      user_id
      status

      device
      modality
      pixels_per_inch

      original_url_both
      original_url_left
      original_url_right

      dicom_url_both
      dicom_url_left
      dicom_url_right

      thumbnail_url_both
      thumbnail_url_left
      thumbnail_url_right

      toolstate_url_both
      toolstate_url_left
      toolstate_url_right

      cad_template_url_left
      cad_template_url_right
    }
  }

  query ListScansByPatientId($patient_id: ID!, $limit: Int, $nextToken: String) {
    listScansByPatientId(patient_id: $patient_id, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenant_ref
        patient_id
        date
        user_id
        status

        device
        modality
        pixels_per_inch

        original_url_both
        original_url_left
        original_url_right

        dicom_url_both
        dicom_url_left
        dicom_url_right

        thumbnail_url_both
        thumbnail_url_left
        thumbnail_url_right

        toolstate_url_both
        toolstate_url_left
        toolstate_url_right

        cad_template_url_left
        cad_template_url_right
      }
      nextToken
    }
  }

  query ListScansByOrderId($order_id: ID!) {
    listScansByOrderId_v2(order_id: $order_id) {
      id
      device
      date
      modality
      pixels_per_inch
      status

      original_url_both
      original_url_left
      original_url_right

      dicom_url_both
      dicom_url_left
      dicom_url_right

      thumbnail_url_both
      thumbnail_url_left
      thumbnail_url_right

      toolstate_url_both
      toolstate_url_left
      toolstate_url_right

      cad_template_url_left
      cad_template_url_right
    }
  }

  mutation CreateScan($input: CreateScanInput!) {
    createScan(input: $input) {
      id
    }
  }

  mutation UpdateScan($input: UpdateScanInput!) {
    updateScan(input: $input) {
      id
    }
  }

  mutation ReplaceScanOutputs($input: ReplaceScanOutputsInput!) {
    replaceScanOutputs(input: $input) {
      scans {
        id
      }
    }
  }

  mutation CreateUploadFilePresignedUrl($tenant_ref: ID!, $filename: String!, $contentType: String!) {
    createUploadFilePresignedUrl(tenant_ref: $tenant_ref, filename: $filename, contentType: $contentType) {
      bucket
      key
      url
      expiresIn
      method
    }
  }

  mutation CreateDownloadFilePresignedUrl($key: String!) {
    createDownloadFilePresignedUrl(key: $key) {
      bucket
      key
      url
      expiresIn
      method
    }
  }

  mutation DeleteScan($scan: DeleteScanInput!) {
    deleteScan(scan: $scan) {
      success
      message
    }
  }
`;
